import { User } from "../users/types"

export type AuthData = UserTokenResponse & {
  generatedAt: number
  expiresAt: number
  /**
   * Set when accounts tells us this session came from a shadow login.
   * Client originated, never returned by the API. Only present when true.
   */
  shadow?: boolean
}

export type UserTokenResponse = {
  accessToken: string
  expiresIn: number
  refreshToken: string
  user: User
}

export type RefreshTokenResponse = Omit<
  AuthData,
  "user" | "generatedAt" | "shadow"
>

export enum SocialAuthProvider {
  GOOGLE = "google",
  FACEBOOK = "facebook",
  APPLE = "apple",
  CLEVER = "clever",
  MICROSOFT = "microsoft",
}

export type SocialAccount = {
  id: string
  provider: SocialAuthProvider
  email: string
  scope: null | string
}
